import Home from '../components/Home';
import Press from '../components/Press';

const indexRoutes = [
		{ path: '/press', name: 'Press', component: Press},
		{ path: '/', name: 'Home', component: Home }
	];

export default indexRoutes;


// WEBPACK FOOTER //
// ./src/routes/index.tsx